import { useEffect } from 'react';
import { IMPRESSUM_URL } from '../config/site';

export default function Impressum() {
  useEffect(() => { window.location.replace(IMPRESSUM_URL); }, []);
  return null;
}
